/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { varianceDependencies } from './dependenciesVariance.generated';
import { createDeprecatedVar } from '../../factoriesAny.js';
export var varDependencies = {
  varianceDependencies: varianceDependencies,
  createDeprecatedVar: createDeprecatedVar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDeprecatedVar.generated.js
// module id = 1387
// module chunks = 0